import { v4 as uuidv4 } from 'uuid';

export const generateUniqueKey = () => {
  const uniqueKey = uuidv4();
  return uniqueKey;
};
